import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.router';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { MediaComponent } from './media/media.component';
import { SearchComponent } from './search/search.component';
import { MemberComponent } from './member/member.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from "app/login/login.service";
import { RegisterService } from "app/register/register.service";
import { HttpModule } from "@angular/http";
import { Router, RouterModule } from "@angular/router";
import { AccountService } from "app/account/account.service";
import { RestService } from "app/webservice/rest.service";
import { AuthGuard } from "app/webservice/authguard.service";
import { LookupService } from "app/webservice/lookup.service";
import { JWTService } from "app/webservice/jwt.service";
import { MemberService } from "app/member/member.service";
import { MediaService } from 'app/media/media.service';
import { HelpersService } from "app/helpers/helpers.service";
import { MediaSearchComponent } from './media-search/media-search.component';
import { CustomData } from './media-search/custom.service';
import { MemberAddComponent } from './member-add/member-add.component';
import { MediaAddComponent } from './media-add/media-add.component';
import { ModalModule } from 'ngx-bootstrap';
import { HistoryComponent } from './history/history.component';
import { SpineLabelComponent } from './spine-label/spine-label.component';
import { PrintSpineLabelComponent } from './print-spine-label/print-spine-label.component';
import { OverdueReportComponent } from './overdue-report//overdue-report.component';
import { ToastModule } from 'ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SetupComponent } from './setup/setup.component';
import { PrintBarcodeComponent } from './print-barcode/print-barcode.component';
import { GridMetadataService } from './clearwave-grid/grid.metadata.service';
import { ClearWaveGridComponent } from './clearwave-grid/clearwave-grid.component';
import { ServiceStackService } from 'app/service-stack-service/service-stack-service.service';
import { HttpClientService } from 'app/http-client-service/http-client-service.service';
import { Ng2CompleterModule } from "ng2-completer";
import { ModalComponent } from 'app/app-modal/app-modal.component';
import { MediaModalComponent } from './media-modal/media-modal.component';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AlphabeticalSortPipe } from './media-search/media-search.component';
import { AssetsByMemberOidPipe } from './overdue-report//overdue-report.component';

@NgModule({
  declarations: [
    AppComponent,
    MediaComponent,
    SearchComponent,
    MemberComponent,
    LoginComponent,
    MediaSearchComponent,
    MemberAddComponent,
    MediaAddComponent,
    HistoryComponent,
    SpineLabelComponent,
    PrintSpineLabelComponent,
    OverdueReportComponent,
    SetupComponent,
    PrintBarcodeComponent,
    ClearWaveGridComponent,
    ModalComponent,
    MediaModalComponent,
    AlphabeticalSortPipe,
    AssetsByMemberOidPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpModule,
    ModalModule.forRoot(),
    ToastModule.forRoot(),
    BrowserAnimationsModule,
    Ng2CompleterModule,
    MultiselectDropdownModule
  ],
providers: [
  ServiceStackService,
  HttpClientService,
  CustomData,
  LoginService,
  RegisterService,
  AccountService,
  RestService,
  AuthGuard,
  LookupService,
  JWTService,
  MemberService,
  HelpersService,
  GridMetadataService,
  MediaService,
  {provide: LocationStrategy, useClass: HashLocationStrategy}
],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/app.module.ts